import { Pipe, PipeTransform } from '@angular/core';
import { DateConversionService } from '../services/date-conversion.service';

@Pipe({
  name: 'isoDate',
  standalone: true
})
export class IsoToFormattedDatePipe implements PipeTransform {

  constructor(private dateConversionService: DateConversionService) { }

  transform(isoTimestamp: string): string {
    return this.dateConversionService.isoToFormattedDate(isoTimestamp);
  }

}
